// import BaseFormPresenter from "../../../../base/BaseFormPresenter";

import { Button, dialog } from "nq-component";
import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";
import { findObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import { SubmitImg } from "../../../../components/common/Converter";
import { v4 as uuidv4 } from "uuid";
import { createNotification } from "../../../../createNotification";

class DPCRFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  // submit form
  async handleFormSubmit() {
    const objectID = uuidv4();
    if (this.view.state.ipcrForm.length === 0) {
      this.showError("Add at least 1 row data");
    } else {
      const currentUser = this.view.state.assignedEmployee;
      const employee = await findObjectUseCase().execute("employees", {
        where: currentUser,
      });

      const noSupervisorAssigned = employee.every((emp) => !emp.supervisor);
      if (noSupervisorAssigned) {
        this.showError("No Supervisor Assigned");
        return;
      }
      const data = {
        id: objectID,
        periodFrom: this.view.state.periodFrom,
        periodTo: this.view.state.periodTo,
        employee: { id: this.view.getCurrentUser().employee.id },
        supervisor: { id: employee[0].supervisor.id },
        performance: this.view.state.ipcrForm,
        assignedEmployee: { id: this.view.state.assignedEmployee.id },
        headPosition: this.view.state.headPosition,
        headName: this.view.state.headName,
        finalPosition: this.view.state.finalPosition,
        finalName: this.view.state.finalName,
      };
      dialog.fire({
        html: (
          <div className="p-2">
            <h4>Confirmation</h4>
            <hr />
            <p style={{ margin: "2rem 0" }}>Click confirm to proceed.</p>
            <hr />
            <div className="w-100 d-flex justify-content-end gap-4 mb-3">
              <Button
                className="btn btn-light fs-sm"
                onClick={() => dialog.close()}
              >
                Cancel
              </Button>
              <Button
                onClick={async () => {
                  if (this.view.getObjectId() !== undefined) {
                    data.id = this.view.getObjectId();
                  }
                  const ArrayFile = await SubmitImg(
                    this.view?.state?.selectedFiles
                  );
                  const ArrayFile2 = await SubmitImg(
                    this.view.state.modifyFiles || []
                  );
                  data.selectedFiles = ArrayFile;
                  data.modifyFiles = ArrayFile2;
                  data.type = "DPCR";
                  await upsertUseCase().execute("dpcr", data);
                  await upsertUseCase().execute("performance", data);

                  dialog.close();
                  this.showSuccess(
                    "You have successfully submitted the performance record."
                  );

                  //  CREATE NOTIFICATION
                  const NOTIFICATION_MESSAGE =
                    "You have a new Performance Request submitted for approval in the My Performances section.";
                  const NOTIFICATION_RECEIVER = [
                    "role:Supervisor",
                    "role:Super Admin",
                  ];
                  const NOTIFICATION_REDIRECT = "performance";

                  createNotification(
                    NOTIFICATION_MESSAGE,
                    NOTIFICATION_RECEIVER,
                    NOTIFICATION_REDIRECT
                  );
                }}
                className="btn btn-primary"
              >
                Confirm
              </Button>
            </div>
          </div>
        ),
        footer: false,
      });
    }
  }
}

export default DPCRFormPresenter;
